export default __webpack_public_path__ + "static/media/NDVI-R.76b073dc.png";